import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '../../../../assets/images/logo.png';
import { Play } from 'lucide-react';
import SocialPlatforms from './SocialPlatforms';
import StreamingPlatforms from './StreamingPlatforms';
import usePreviewBackground from './usePreviewBackground';

export default function LinkPreviewAdvancedLayout({ previewData }) {
    const {
        background,
        release,
        player,
        socialPlatforms,
        streamingPlatforms,
        mode
    } = previewData;

    const bg = usePreviewBackground(background, release);
    return (
        <div className="device-wrapper w-full relative bg-cover bg-center rounded-[36px] border-8 border-[#B2B2B2] overflow-hidden"
            style={{ background: bg.background }}
        >
            {/* Blur Background Layer */}
            {bg.blur && (
                <div
                    className="absolute inset-0 scale-125 blur-3xl"
                    style={{
                        backgroundImage: `url(${release.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                />
            )}

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/50"></div>

            {/* Notch */}
            <div className="absolute top-[10px] left-1/2 transform -translate-x-1/2 bg-black h-6 w-24 border border-light rounded-full z-10"></div>

            {/* Screen Content */}
            <div className="relative pt-12 pb-4 px-8">

                <div className="content-wrapper rounded overflow-hidden mb-6">
                    {/* Video Player Area */}
                    {/* <div className="top-section relative w-full aspect-video bg-cover bg-center overflow-hidden shadow-lg min-h-40"
                        style={{ backgroundImage: `url(${release.image})` }}
                    >
                        <div className="absolute inset-0 flex items-center justify-center">
                            <button className="bg-white/20 backdrop-blur-md hover:bg-white/30 rounded-full p-4 transition-all duration-300 transform hover:scale-110">
                                <Play className="w-8 h-8 text-white fill-white" />
                            </button>
                        </div>
                        <div className="absolute top-0 left-0 w-32 h-32 bg-blue-300 rounded-full blur-3xl opacity-30"></div>
                    </div> */}
                    <div
                        className="top-section relative w-full aspect-square bg-cover bg-center overflow-hidden shadow-2xl group"
                        style={{ backgroundImage: `url(${release.image})` }}
                    >
                        {/* Gradient overlay (darkens bottom like music players) */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                        {/* Soft glow effect */}
                        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white/20 blur-3xl opacity-30"></div>
                        {/* Hover animation */}
                        <div className="absolute inset-0 transition-transform duration-500 group-hover:scale-105"></div>
                        {/* Play Button */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <button className="bg-white/20 backdrop-blur-md hover:bg-white/30 rounded-full p-4 transition-all duration-300 transform hover:scale-110 shadow-xl">
                                <Play className="w-8 h-8 text-white fill-white" />
                            </button>
                        </div>
                    </div>

                    <div className="bottom-section bg-[#434343]">
                        <div className="brand-wrapper border-y border-gray-500 px-3 py-2">
                            <img src={AppLogo} alt="App Logo" className="h-7 mx-auto" />
                        </div>

                        <div className="wrapper p-3">
                            {/* Title and Track Section */}
                            <div className="text-center mb-4">
                                <h2 className="text-white text-base font-bold mb-[2px]">{release.name || 'Track Name'}</h2>
                                <p className="text-gray-300 text-sm">{mode === "presave" ? release.subtitle : (release.subtitle || `Listen to my new track ${release?.name || ""}`)}</p>
                            </div>

                            {/* Base Layout */}
                            <div className="list-wrapper max-h-[250px] space-y-2 overflow-auto">
                                <StreamingPlatforms
                                    platforms={streamingPlatforms}
                                    variant="advanced"
                                    mode={mode}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Social Media Icons */}
                <div className="flex flex-wrap justify-center gap-3">
                    <SocialPlatforms
                        platforms={socialPlatforms}
                        variant="advance"
                    />
                </div>

                <hr className="border-gray-600 my-4" />

                {/* Footer Title */}
                <div className="logo-wrapper text-center mb-4">
                    <img src={AppLogo} alt="App Logo" className="h-7 mx-auto" />
                </div>

                {/* Footer Text */}
                <div className="text-center mb-4">
                    <p className="text-gray-300 text-xs leading-relaxed">
                        By using this site you agree to our <Link to={'/terms-of-service'} className="text-white font-bold">Terms of Use</Link> and <Link to={'/privacy-policy'} className="text-white font-bold">Privacy Policy</Link>
                    </p>
                </div>

                {/* Copyright */}
                <div className="text-center">
                    <p className="text-gray-300 text-xs">Copyright © 2026</p>
                </div>
            </div>
        </div>
    );
}